import WhatsNewPopUpModal from 'src/components/WhatsNewPopUpModal.svelte';
import { home_data, user_data } from 'src/stores/account/user';
import { network } from 'src/stores/session/native-bridge';
import type { ModalConfig } from 'src/types/Modals';
import { get } from 'svelte/store';
import { NoPremiumVoucherCheckRule } from './rules/NoPremiumVoucherRule';
import { fetchChangelogVersions } from 'src/services/changelog';
import { hasSeenWhatsNewOnDevice } from 'src/helpers/whats_new_helpers';
import { compare } from 'compare-versions';
import { version as runningAppVersion } from '../../../package.json';

const getWhatsNewDateTimestamp = async () => {
	try {
		const versions = await fetchChangelogVersions();
		const latestRelease = versions[0];
		if (!latestRelease) return null;

		if (latestRelease.appVersion && compare(runningAppVersion, latestRelease.appVersion, '<')) {
			return null;
		}

		const dateTimestamp = latestRelease.timestamp;
		const homeData = get(home_data);
		const userData = get(user_data);

		const shouldShowFromBackend = homeData?.whatsNew
			? dateTimestamp > homeData.whatsNew
			: dateTimestamp > userData.regts;

		if (!shouldShowFromBackend) return null;

		// Additional device-local guard on top of the backend per-home flag
		if (hasSeenWhatsNewOnDevice(dateTimestamp)) return null;

		return dateTimestamp;
	} catch {
		return null;
	}
};

export const WhatsNewModalConfig = async (): Promise<ModalConfig> => {
	const whatsNewDateTimestamp = await getWhatsNewDateTimestamp();

	return {
		id: 'whatsNewState',
		component: WhatsNewPopUpModal,
		props: {
			priority: 40, // Low priority
			showModal: true,
			whatsNewDateTimestamp,
		},
		rules: [
			{
				check: () => get(network) !== 'offline' && !!whatsNewDateTimestamp,
				expected: true,
			},
			NoPremiumVoucherCheckRule,
		],
	};
};
